/* Shared support-ticket action. Each skin supplies its own DOM and initial topic. */
(function () {
  'use strict';
  function init(options) {
    var fab = options.fab;
    var sheet = options.sheet;
    if (!fab || !sheet) return;
    var form = sheet.querySelector('[data-ticket-form]');
    var topics = Array.prototype.slice.call(sheet.querySelectorAll('[data-ticket-topic]'));
    var orderField = sheet.querySelector('[data-ticket-order]');
    var orderInput = sheet.querySelector('[data-ticket-order-input]');
    var subjectField = sheet.querySelector('[data-ticket-subject-field]');
    var subjectInput = sheet.querySelector('[data-ticket-subject-input]');
    var subjectError = sheet.querySelector('[data-ticket-subject-error]');
    var autoSubject = sheet.querySelector('[data-ticket-auto-subject]');
    var autoSubjectValue = sheet.querySelector('[data-ticket-auto-subject-value]');
    var detailsInput = sheet.querySelector('[data-ticket-details]');
    var configError = sheet.querySelector('[data-ticket-config-error]');
    var status = sheet.querySelector('[data-ticket-status]');
    var submitButton = sheet.querySelector('.dn-ticket__submit');
    var prompt = sheet.querySelector('[data-ticket-prompt]');
    var selected = null;

    function recipient() { return String(sheet.getAttribute('data-support-email') || '').trim(); }
    function validRecipient(value) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); }
    function clearSubjectError() {
      subjectField.classList.remove('has-error');
      subjectInput.removeAttribute('aria-invalid');
      subjectError.hidden = true;
    }
    function showSubjectError() {
      subjectField.classList.add('has-error');
      subjectInput.setAttribute('aria-invalid', 'true');
      subjectError.hidden = false;
      subjectInput.focus();
    }
    function checkConfig() {
      var ok = validRecipient(recipient());
      configError.hidden = ok;
      submitButton.disabled = !ok;
      submitButton.setAttribute('aria-disabled', ok ? 'false' : 'true');
      return ok;
    }
    function setTopic(id) {
      selected = null;
      topics.forEach(function (topic) {
        var on = topic.getAttribute('data-ticket-topic') === id;
        topic.classList.toggle('is-selected', on);
        topic.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) selected = topic;
      });
      clearSubjectError();
      status.hidden = true;
      form.removeAttribute('data-generated-mailto');
      if (!selected) {
        form.hidden = true;
        prompt.hidden = false;
        return;
      }
      form.hidden = false;
      prompt.hidden = true;
      var idNow = selected.getAttribute('data-ticket-topic');
      var isOther = idNow === 'other';
      orderField.hidden = idNow !== 'track';
      subjectField.hidden = !isOther;
      autoSubject.hidden = isOther;
      autoSubjectValue.textContent = selected.getAttribute('data-ticket-subject') || '';
    }

    topics.forEach(function (topic) {
      topic.addEventListener('click', function () { setTopic(topic.getAttribute('data-ticket-topic')); });
    });
    subjectInput.addEventListener('input', function () { if (subjectInput.value.trim()) clearSubjectError(); });
    sheet.querySelector('[data-ticket-another]').addEventListener('click', function () { setTopic(null); });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!selected) return;
      var topicId = selected.getAttribute('data-ticket-topic');
      var finalSubject = topicId === 'other' ? subjectInput.value.trim() : selected.getAttribute('data-ticket-subject');
      if (topicId === 'other' && !finalSubject) { showSubjectError(); return; }
      if (!checkConfig()) { status.hidden = true; form.removeAttribute('data-generated-mailto'); return; }
      var lines = ['Topic: ' + selected.getAttribute('data-ticket-label')];
      if (topicId === 'track' && orderInput.value.trim()) lines.push('Order number: ' + orderInput.value.trim());
      lines.push('', detailsInput.value.trim());
      var mailto = 'mailto:' + recipient() + '?subject=' + encodeURIComponent(finalSubject) + '&body=' + encodeURIComponent(lines.join('\n'));
      form.setAttribute('data-generated-mailto', mailto);
      status.hidden = false;
      var draftLink = document.createElement('a');
      draftLink.href = mailto;
      draftLink.setAttribute('aria-hidden', 'true');
      draftLink.tabIndex = -1;
      draftLink.style.display = 'none';
      document.body.appendChild(draftLink);
      draftLink.click();
      draftLink.remove();
    });

    new MutationObserver(function () {
      checkConfig();
    }).observe(sheet, { attributes: true, attributeFilter: ['data-support-email'] });

    fab.addEventListener('click', function () {
      try { localStorage.setItem('dn2_chat_seen', '1'); } catch (e) {}
      var badge = fab.querySelector('[data-chat-badge]');
      if (badge) badge.style.display = 'none';
      if (window.DN2 && window.DN2.openSheet) window.DN2.openSheet(sheet);
      else { sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false'); }
    });
    try {
      if (localStorage.getItem('dn2_chat_seen') === '1') {
        var seenBadge = fab.querySelector('[data-chat-badge]');
        if (seenBadge) seenBadge.style.display = 'none';
      }
    } catch (e) {}
    checkConfig();
    setTopic(options.initialTopic);
  }
  window.dn = window.dn || {};
  window.dn.ticket = { init: init };
})();
